/* ETHEM tema — AJAX sepet çekmecesi (bağımlılıksız)
   Global API: window.EthemSepet — ekle(variantId, adet), ac(), kapat(), tazele()
   Çekmece kökü: #SepetCekmece · satır şablonu: #SepetSatirSablon
   AJAX'lanan formlar: form[data-ajax-sepet] · açma tetikleri: [data-sepet-ac] */
(function () {
  'use strict';
  if (window.EthemSepet) return;

  var kok = document.getElementById('SepetCekmece');
  var sablon = document.getElementById('SepetSatirSablon');
  if (!kok || !sablon) return;

  var panel = kok.querySelector('.sepet-cekmece__panel');
  var ortu = kok.querySelector('[data-cekmece-ortu]');
  var govde = kok.querySelector('[data-cekmece-govde]');
  var bosEl = kok.querySelector('[data-cekmece-bos]');
  var altEl = kok.querySelector('[data-cekmece-alt]');
  var toplamEl = kok.querySelector('[data-cekmece-toplam]');
  var baslikAdetEl = kok.querySelector('[data-cekmece-adet]');
  var hataEl = kok.querySelector('[data-cekmece-hata]');
  var kapatBtn = kok.querySelector('[data-cekmece-kapat]');

  var paraBicimi = new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    maximumFractionDigits: 0
  });

  var yuklendi = false;   // /cart.js en az bir kez okundu mu
  var mesgul = false;     // satır güncelleme kilidi (yarış önleme)
  var oncekiOdak = null;

  /* ---------- yardımcılar ---------- */

  function para(kurus) { return paraBicimi.format(kurus / 100); }

  function boyutluGorsel(url, genislik) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + genislik;
  }

  function hataGoster(mesaj) {
    if (!hataEl) return;
    hataEl.textContent = mesaj || 'Bir sorun oluştu. Lütfen tekrar deneyin.';
    hataEl.hidden = false;
  }

  function hataGizle() {
    if (hataEl) hataEl.hidden = true;
  }

  function jsonYanit(r, varsayilanMesaj) {
    return r.json().catch(function () {
      throw new Error(varsayilanMesaj);
    }).then(function (veri) {
      if (!r.ok) {
        throw new Error(veri.description || veri.message || varsayilanMesaj);
      }
      return veri;
    });
  }

  function rozetleriGuncelle(adet) {
    document.querySelectorAll('.site-baslik__sepet-adet').forEach(function (el) {
      el.textContent = adet;
    });
    if (baslikAdetEl) baslikAdetEl.textContent = adet;
  }

  /* ---------- çizim ---------- */

  function ciz(sepet) {
    yuklendi = true;
    govde.querySelectorAll('[data-satir]').forEach(function (el) { el.remove(); });

    var bos = !sepet.items || sepet.item_count === 0;
    if (bosEl) bosEl.hidden = !bos;
    if (altEl) altEl.hidden = bos;

    (sepet.items || []).forEach(function (item) {
      var satir = sablon.content.firstElementChild.cloneNode(true);
      satir.setAttribute('data-satir-anahtar', item.key);

      var urlEl = satir.querySelector('[data-alan="url"]');
      var gorselEl = satir.querySelector('[data-alan="gorsel"]');
      var adEl = satir.querySelector('[data-alan="ad"]');
      var varyantEl = satir.querySelector('[data-alan="varyant"]');

      if (urlEl) urlEl.href = item.url;
      if (adEl) { adEl.href = item.url; adEl.textContent = item.product_title; }
      if (gorselEl) {
        if (item.image) {
          gorselEl.src = boyutluGorsel(item.image, 144);
          gorselEl.alt = item.product_title;
        } else {
          gorselEl.remove();
        }
      }
      if (varyantEl) {
        if (item.variant_title && item.variant_title !== 'Default Title') {
          varyantEl.textContent = item.variant_title;
        } else {
          varyantEl.remove();
        }
      }
      satir.querySelector('[data-alan="birim-fiyat"]').textContent = para(item.final_price);
      satir.querySelector('[data-alan="adet"]').textContent = item.quantity;
      satir.querySelector('[data-alan="satir-toplam"]').textContent = para(item.final_line_price);

      govde.appendChild(satir);
    });

    if (toplamEl) toplamEl.textContent = para(sepet.total_price);
    rozetleriGuncelle(sepet.item_count);
  }

  /* ---------- API ---------- */

  function tazele() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return jsonYanit(r, 'Sepet yüklenemedi.'); })
      .then(function (sepet) { ciz(sepet); return sepet; });
  }

  function ac() {
    if (!kok.classList.contains('acik')) {
      if (!yuklendi) {
        tazele().catch(function (hata) { hataGoster(hata.message); });
      }
      oncekiOdak = document.activeElement;
      kok.classList.add('acik');
      document.body.style.overflow = 'hidden';
      if (kapatBtn) kapatBtn.focus();
    }
  }

  function kapat() {
    if (!kok.classList.contains('acik')) return;
    kok.classList.remove('acik');
    document.body.style.overflow = '';
    hataGizle();
    if (oncekiOdak && typeof oncekiOdak.focus === 'function') oncekiOdak.focus();
    oncekiOdak = null;
  }

  function ekle(variantId, adet) {
    hataGizle();
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: adet || 1 })
    })
      .then(function (r) { return jsonYanit(r, 'Ürün sepete eklenemedi.'); })
      .then(function (veri) {
        return tazele().then(function () { ac(); return veri; });
      })
      .catch(function (hata) {
        ac();
        hataGoster(hata.message);
        throw hata;
      });
  }

  function satirDegistir(anahtar, adet) {
    if (mesgul) return Promise.resolve();
    mesgul = true;
    hataGizle();
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: anahtar, quantity: adet })
    })
      .then(function (r) { return jsonYanit(r, 'Sepet güncellenemedi.'); })
      .then(function (sepet) { ciz(sepet); })
      .catch(function (hata) { hataGoster(hata.message); })
      .finally(function () { mesgul = false; });
  }

  window.EthemSepet = { ekle: ekle, ac: ac, kapat: kapat, tazele: tazele };

  /* ---------- olaylar ---------- */

  // Çekmece içi: kapatma, adet +/- ve satır silme (satırlar dinamik → delegasyon)
  kok.addEventListener('click', function (e) {
    if (e.target === ortu || e.target.closest('[data-cekmece-kapat]')) {
      kapat();
      return;
    }
    var adetBtn = e.target.closest('[data-adet-degistir]');
    if (adetBtn) {
      var satir = adetBtn.closest('[data-satir-anahtar]');
      if (!satir) return;
      var adetSpan = satir.querySelector('[data-alan="adet"]');
      var mevcut = parseInt(adetSpan && adetSpan.textContent, 10) || 0;
      var yeni = mevcut + (parseInt(adetBtn.getAttribute('data-adet-degistir'), 10) || 0);
      if (yeni < 0) yeni = 0;
      if (yeni !== mevcut) satirDegistir(satir.getAttribute('data-satir-anahtar'), yeni);
      return;
    }
    var silBtn = e.target.closest('[data-satir-sil]');
    if (silBtn) {
      var silSatir = silBtn.closest('[data-satir-anahtar]');
      if (silSatir) satirDegistir(silSatir.getAttribute('data-satir-anahtar'), 0);
    }
  });

  // Açma tetikleri (dinamik içerik dahil)
  document.addEventListener('click', function (e) {
    var tetik = e.target.closest('[data-sepet-ac]');
    if (tetik) {
      e.preventDefault();
      ac();
    }
  });

  // data-ajax-sepet formları: submit'i yakala, FormData'dan id + quantity
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-ajax-sepet]') : null;
    if (!form) return;
    e.preventDefault();

    var veri = new FormData(form);
    var id = veri.get('id');
    if (!id) return;
    var adet = parseInt(veri.get('quantity'), 10) || 1;

    var buton = form.querySelector('[type="submit"]');
    var eskiDurum = buton ? buton.disabled : false;
    if (buton) buton.disabled = true;

    ekle(id, adet)
      .catch(function () { /* hata bandı çekmecede gösterildi */ })
      .finally(function () { if (buton) buton.disabled = eskiDurum; });
  });

  // ESC ile kapat
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && kok.classList.contains('acik')) kapat();
  });

  // Basit odak tuzağı — Tab panel içinde döner
  panel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var odaklar = Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!odaklar.length) return;
    var ilk = odaklar[0];
    var son = odaklar[odaklar.length - 1];
    if (e.shiftKey && document.activeElement === ilk) {
      e.preventDefault();
      son.focus();
    } else if (!e.shiftKey && document.activeElement === son) {
      e.preventDefault();
      ilk.focus();
    }
  });
})();

/* Kart üstü hızlı sepete ekleme (2026-08-17) */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-hizli-ekle]');
  if (!b || !window.EthemSepet) return;
  e.preventDefault();
  e.stopPropagation();
  b.disabled = true;
  var eskiMetin = b.textContent;
  b.textContent = 'Ekleniyor…';
  EthemSepet.ekle(b.getAttribute('data-hizli-ekle'), 1)
    .catch(function () {})
    .finally(function () { b.disabled = false; b.textContent = eskiMetin; });
});
